module.exports = __webpack_public_path__ + "img/qpay.56a4a32c.png";